<template>
	<div class="course">
		<HeadModule v-if="trainId" :openTarget="'CFClass/detail?hideNativeNav=1&courseId='+ courseId + '&trainId=' + trainId"/>
		<HeadModule v-else :openTarget="'CFClass/detail?hideNativeNav=1&courseId='+ courseId"/>
		<!-- 课程内容 -->
		<div class="header-bg">
			<div class="bg-img">
				<van-image lazy-load :src="cover" fit="cover" />
			</div>
		</div>
		<!-- 介绍 -->
		<div class="tabs">
			<van-tabs v-model="currentIdx">
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>介绍</span>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<Introduce v-if="courseInfo" :trainId="trainId" :courseInfo="courseInfo"
							           @changeTabs="changeTabs"></Introduce>
						</div>
					</template>
				</van-tab>
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>目录</span>
							<div class="try-mark" v-if="courseInfo.canTryLook">试看</div>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<Catalog v-if="courseInfo" :trainId="trainId" :courseInfo="courseInfo"></Catalog>
						</div>
					</template>
				</van-tab>
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>评论</span>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<Comment v-if="courseInfo.id" :trainId="courseInfo.id" :type="1"></Comment>
						</div>
					</template>
				</van-tab>
			</van-tabs>
		</div>
		<div class="big-btn">
			<div class="pay">去电巢APP学习</div>
			<WxOpenTag v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseId + '&trainId=' + trainId" />
			<WxOpenTag v-else :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseId" />
		</div>
	</div>
</template>
<script>
import HeadModule from "@/components/HeadModule"
import WxOpenTag from "@/components/WxOpenTag.vue";
import WxShare from "@/utils/wxshare";
import { getImageUrl,isHttp } from "@/utils/upload";
import Comment from "@/page/training/components/Comment.vue";
import Catalog from "@/page/trainingCourse/components/Catalog.vue";
import Introduce from "@/page/trainingCourse/components/Introduce.vue";

export default {
	components: {
		Comment,
		WxOpenTag,
		HeadModule,
		Catalog,
		Introduce
	},
	data() {
		return {
			// 当前tab
			currentIdx: 0,
			courseInfo: {},
			editorScroll: null,
			cover: '', // 封面
			courseId: '',
			trainId: '',
		}
	},
	created() {
		this.trainId = this.$route.query.trainId ? this.$route.query.trainId : ""
		this.courseId = this.$route.query.courseId ? this.$route.query.courseId : ""
		this.init();
		this.viewTrain();
		this.getCourseDetail();
	},
	methods: {
		init() {
			this.getWx = new WxShare();
		},
		// 培训计划详情记录浏览数据 kc/app/cTrain/view
		viewTrain(){
			// 请求接口/app/cTrain/view
			let formData = new FormData();
			formData.append('api', 'kc/app/cTrain/view');
			formData.append('resourceId', this.courseId);
			formData.append('type', 1);
			this.$http({
				url: '/ipd/commonApi',
				method: 'post',
				data: formData
			})
		},
		// 获取课程详情
		getCourseDetail() {
			let formData = new FormData();
			formData.append('api', 'kc/app/cTrain/curriculum/detail');
			formData.append('id', this.courseId);
			this.$http({
				url: '/ipd/commonApi',
				method: 'post',
				data: formData
			}).then(res => {
				if (res.code === 0) {
					this.courseInfo = res.data;
					// 改变h5标题
					document.title = this.courseInfo.name ? this.courseInfo.name : "课程详情";
					// 封面
					if(this.courseInfo.cover){
						getImageUrl(this.courseInfo.cover, (imgUrl) => {
							this.cover = imgUrl
							/* 微信分享 */
							this.getWx.share({
								title: this.courseInfo.name,
								desc: '电子产业链人才智慧培养和提升一站式数字化服务平台',
								link: window.location.href,
								imgUrl: this.cover
							});
						})
					}
					// 讲师列表
					if(this.courseInfo.lecturerList && this.courseInfo.lecturerList.length > 0){
						// 处理头像
						this.courseInfo.lecturerList.forEach((item) => {
							if(item.photo && !isHttp(item.photo)){
								getImageUrl(item.photo,(imgUrl)=>{
									this.$set(item,'photoUrl',imgUrl)
								})
							}else{
								this.$set(item,'photoUrl',item.photo)
							}
						});
					}
				}else if(res.code < 0){
					// 不存在或者下架
					this.$router.replace({
						path: '/learningEmpty',
					})
				}
			})
		},
		changeIdx(index) {
			this.currentIdx = index;
		},
		changeTabs() {
			this.currentIdx = 1;
		}
	},
}
</script>
<style scoped lang="css">
*{
	box-sizing: border-box;
}
.course{
	display: flex;
	flex-direction: column;
	position: relative;
	background: #F7F8F8;
	padding-bottom: 98px;
	min-height: 100%;
}
.header-bg{
	position: relative;
	width: 100%;
	height: 205px;
}
.bg-img{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
}
.bg-img .van-image{
	width: 100%;
	height: 100%;
}
.big-btn{
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 1100;
	background: #FFFFFF;
	padding: 10px 15px 10px;
	box-sizing: border-box;
}
.big-btn .pay{
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 49px;
	background: #E6001F;
	border-radius: 24px;
	font-size: 18px;
	color: #FFFFFF;
}
.tabs{
	flex: 1;
	background: #FFFFFF;
	margin-bottom: 15px;
}
::v-deep .van-tabs__wrap{
	position: sticky;
	top: 0;
	z-index: 1100;
	height: 45px;
	border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
	background-color: #fff;
	box-sizing: border-box;
}
::v-deep .van-tabs__wrap .van-tabs__nav{
	padding: 0 26px;
	justify-content: space-between;
}
::v-deep .van-tabs__wrap .van-tabs__line{
	bottom: 0;
}
::v-deep .van-tabs__wrap .van-tabs__nav .van-tab{
	flex: none;
	padding: 0;
}
::v-deep .van-tabs__wrap .van-tab__text{
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	overflow: initial;
}
::v-deep .van-tabs__wrap .van-tab--active .van-tab__text{
	color: #E6001F;
	font-weight: 600;
}
.tab-item{
	position: relative;
	display: flex;
	align-items: center;
}
.tab-item .try-mark{
	position: absolute;
	right:-46px;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 21px;
	background: #FFFFFF;
	border-radius: 11px;
	border: 1px solid #F7443F;
	font-size: 11px;
	color: #F7443F;
	padding: 3px 8px;
	font-weight: 400;
	z-index: 1200;
}
.tab-content{
	flex: 1;
	background: #fff;
}


</style>